// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.msgbox {\n  width: 65vw;\n  margin-top: 15vh;\n  margin-left: 15vw;\n  margin-right: auto;\n}\n.btnDiv {\n  width: 40vw;\n}\n.imgloco {\n  float: left;\n}\n.scan-logo-size {\n  height: 50px;\n  padding: 0%;\n  float: left;\n  margin-top: 10px;\n  margin-left: 15px;\n}\n.backbtn {\n  background-color: #00368f;\n  border-color: #00368f;\n  width: auto;\n  margin-top: 10px;\n  float: right;\n}\n", ""]);
// Exports
module.exports = exports;
